module.exports = __webpack_public_path__ + "h5/img/dsh.e2020642.png";